export const urlCacheParam: boolean | undefined = (() => {
  try {
    if (new URLSearchParams(window.location.search).get('cache') === '0') {
      return false;
    }
  } catch (error) {
    //
  }
})();
